/**
 *
 *  NextButton
 *  TruBe Date Time AvailabilityCalendar Next Button Component
 *
 *  Created by Vladimir Shishlyannikov on 24/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

export default function NextButton({
  className,
  buttonClassName,
  onPress,
  visible,
}) {
  return (
    <div
      className={`button-control button-next tbk-absolute tbk-z-10 tbk-flex tbk-h-full tbk-items-end tbk-opacity-0 md:tbk-transition-opacity md:tbk-duration-200 md:tbk-ease-in-out ${
        visible ? "md:tbk-opacity-100" : "tbk-opacity-0"
      }${className ? ` ${className}` : ""}`}
    >
      <button
        className={`${buttonClassName} calendar-btn tbk-inline-flex tbk-h-4 tbk-w-4 tbk-items-center tbk-justify-center tbk-rounded-full tbk-bg-basic-white tbk-text-blue-dark tbk-shadow-trube `}
        onClick={onPress}
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            display: "block",
            fill: "currentcolor",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.62268e-07 11.5L1.5 13L8 6.5L1.5 2.62268e-07L2.01072e-06 1.5L5 6.5L2.62268e-07 11.5Z"
          />
        </svg>
      </button>
    </div>
  );
}
